import uuid from "uuid";
import { PanelDef } from "../PanelDef";
import { ViewAggregateValue } from "./ViewAggregateValue";
import { EditAggregateValueMeta } from "./EditAggregateValueMeta";

export class AggregateValueMetaData {
  type = "aggregate_value";
  table: string = "";
  column: string = "";
  prefix: string = "";
  suffix: string = "";
  aggregator: Array<string> = [];
  second_aggregator?: string;
  aggregate_over_first_result?: boolean;
  id: string = uuid.v4();
  title: string = "";
  description: string = "";
  textSize: number = 50;
  autoTextSize: boolean = true;
  enableUnits: boolean = false;
  autoScaleUnits: boolean = false;
  enableRoundoff: boolean = true;
  roundOffPrecision: number = 3;
}

type AggregateValueDataItem = {
  [key: string]: number | string | null;
};

export type AggregateValueNestedData =
  | AggregateValueDataItem
  | {
      [key: string]: AggregateValueDataItem;
    };

export type AggregateValueData = {
  data:
    | { value: number }
    | { [key: string]: AggregateValueNestedData }
    | { [key: string]: AggregateValueNestedData }[];
};

export const AggregateValuePanelDef: PanelDef<
  AggregateValueMetaData,
  AggregateValueData
> = {
  ViewComponent: ViewAggregateValue,
  EditComponent: EditAggregateValueMeta,
  formatData: (data) => data,
  metaConstructor: AggregateValueMetaData,
  previewAspectRatio: { width: 500, height: 300 },
};
